// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ue-z","play":"ve-z"};